import Settings from "./settings.service";
import { BehaviorSubject } from "rxjs";
import HTTP from "./http.service";

let loaded = false;
let loaded_obsrv = new BehaviorSubject(loaded);
let activeLang = "en";

let keys = {};
let strings = {};
keys[activeLang] = {};

// let used = [];

const t = (key) => {
	// return "";

	if (key === "") {
		console.warn("Translation key empty");
	} else {
		// if (used.indexOf(key) === -1) {
		// 	used.push(key);
		// }
		// console.info("Translation key used: " + key);
		if (!strings[key]) {
			console.warn("Translation key not found: " + key);
		}
	}
	return strings[key] || "";
};

const getPatch = (key, val) => {
	return {
		operation: "upsert",
		key: key,
		value: {
			en: val || "",
			ar: "",
		},
	};
};

const getAvailableLanguages = () => {
	return Object.keys(keys);
};

const getCurrentLanguage = () => {
	return activeLang;
};

const loadBackupTranslations = () => {
	let backup = require("../translations/backup.json");
	keys = backup;
	strings = keys[activeLang];
	loaded_obsrv.next(true);
	loaded_obsrv.complete();
};

const fetch = () => {
	let config = {
		method: "get",
		url: "/translations",
		params: {
			container_id: Settings.translations_container,
		},
	};
	HTTP(config)
		.then((data) => {
			if (data.data && data.data[activeLang]) {
				keys = data.data;
				strings = keys[activeLang];
				loaded_obsrv.next(true);
				loaded_obsrv.complete();
			} else {
				loadBackupTranslations(activeLang);
			}
		})
		.catch((error) => {
			loadBackupTranslations(activeLang);
		});
};

const getTranslations = () => {
	fetch();
	return loaded_obsrv;
};

const groupTextsStartWithKey = (key) => {
	if (!key) return null;
	let allKeys = Object.keys(strings);
	let filtered =  allKeys?.filter(str=>str.startsWith(key));
	return filtered?.map(key=>strings[key]);
}
export {
	t,
	getTranslations,
	getCurrentLanguage,
	getAvailableLanguages,
	getPatch,
	groupTextsStartWithKey
};
